const web_component_base = require('./web-component-base.css.js');
const wc_accordion = require('./wc-accordion.css.js');
const wc_awards = require('./wc-awards.css.js');
const wc_banner = require('./wc-banner.css.js');
const wc_case = require('./wc-case.css.js');
const wc_content = require('./wc-content.css.js');
const wc_emergency_message = require('./wc-emergency-message.css.js');
const wc_features_banner = require('./wc-features-banner.css.js');
const wc_links_panel = require('./wc-links-panel.css.js');
const wc_message_bar = require('./wc-message-bar.css.js');
const wc_notification = require('./wc-notification.css.js');
const wc_nutshell = require('./wc-nutshell.css.js');
const wc_panoramic = require('./wc-panoramic.css.js');
const wc_product = require('./wc-product.css.js');
const wc_promo = require('./wc-promo.css.js');
const wc_scrolling_bar = require('./wc-scrolling-bar.css.js');
const wc_split_banner = require('./wc-split-banner.css.js');
const wc_spotlight_promo = require('./wc-spotlight-promo.css.js');
const wc_summary = require('./wc-summary.css.js');
const wc_table = require('./wc-table.css.js');
const wc_terms_conditions_copy = require('./wc-terms-conditions-copy.css.js');
const wc_usps_bar = require('./wc-usps-bar.css.js');
const wc_age_gate_modal = require('./wc-age-gate-modal.css.js');
const wc_consent_manage_modal = require('./wc-consent-manage-modal.css.js');
const wc_consent_modal = require('./wc-consent-modal.css.js');
const wc_gift_reminders_modal = require('./wc-gift-reminders-modal.css.js');
const wc_raf_modal = require('./wc-raf-modal.css.js');
const wc_resubscribe_modal = require('./wc-resubscribe-modal.css.js');
const wc_voucher_conflict_modal = require('./wc-voucher-conflict-modal.css.js');
const wc_voucher_modal = require('./wc-voucher-modal.css.js');

module.exports = {
  'web-component-base': web_component_base,
  'wc-accordion': wc_accordion,
  'wc-awards': wc_awards,
  'wc-banner': wc_banner,
  'wc-case': wc_case,
  'wc-content': wc_content,
  'wc-emergency-message': wc_emergency_message,
  'wc-features-banner': wc_features_banner,
  'wc-links-panel': wc_links_panel,
  'wc-message-bar': wc_message_bar,
  'wc-notification': wc_notification,
  'wc-nutshell': wc_nutshell,
  'wc-panoramic': wc_panoramic,
  'wc-product': wc_product,
  'wc-promo': wc_promo,
  'wc-scrolling-bar': wc_scrolling_bar,
  'wc-split-banner': wc_split_banner,
  'wc-spotlight-promo': wc_spotlight_promo,
  'wc-summary': wc_summary,
  'wc-table': wc_table,
  'wc-terms-conditions-copy': wc_terms_conditions_copy,
  'wc-usps-bar': wc_usps_bar,
  'wc-age-gate-modal': wc_age_gate_modal,
  'wc-consent-manage-modal': wc_consent_manage_modal,
  'wc-consent-modal': wc_consent_modal,
  'wc-gift-reminders-modal': wc_gift_reminders_modal,
  'wc-raf-modal': wc_raf_modal,
  'wc-resubscribe-modal': wc_resubscribe_modal,
  'wc-voucher-conflict-modal': wc_voucher_conflict_modal,
  'wc-voucher-modal': wc_voucher_modal,
};
